// Cache Storage names shared with the service worker (src/sw.ts).

export const API_CACHE = 'plume-api-v1';
export const COVER_CACHE = 'plume-covers-v1';

async function deleteCaches(names: string[]): Promise<void> {
  if (typeof caches === 'undefined') return;
  await Promise.all(names.map((name) => caches.delete(name).catch(() => false)));
}

/** Drops cached API responses (user-specific JSON) but keeps cover art. Used when switching connections. */
export function clearApiCache(): Promise<void> {
  return deleteCaches([API_CACHE]);
}

/** Drops cached API responses and covers (sign-out, session expiry). */
export function clearAllUserCaches(): Promise<void> {
  return deleteCaches([API_CACHE, COVER_CACHE]);
}
